import React from 'react'
import AppsTestimonials from '../../molecules/AppsTestimonials/AppsTestimonials'
import CompanyLogoImage from '../../molecules/CompanyLogoImage/CompanyLogoImage'
import ContactHelp from '../../molecules/ContactHelp/ContactHelp'
import Footer from '../Footer/Footer'

const DefaultFooter = () => {
    return (
        <div>
            <AppsTestimonials color='var(--color-primary)' bgcolor='bg-yellow' textColor='black' activeTextColor='white' />
            <div className='p-4 sm:p-6 md:p-10 px-4 sm:px-8 md:px-16 lg:px-36' >
                <CompanyLogoImage />
            </div>
            <ContactHelp title="Let's connect & achieve your business goals together" buttonTitle='CONTACT US' />
            <Footer />
        </div>
    )
}

export default DefaultFooter
